export const injectRecaptchaScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.nonce = 'this_is_my_nonce';
  script.async = true;
  script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LchCGEqAAAAADcpPOSXS8m8E5KAl8oVtdq5brk6';

  document.head.appendChild(script);
};
